import { shopScene } from '../shopkit.js';

/** 早点铺／面馆：垫肚子的地方，也是"干净"最容易丢的地方。 */
export const eateryDoc = shopScene({
  id: 'eatery',
  name: '早点铺',
  shop: 'eatery',
  owner: '面婶',
  desc: '一口大锅咕嘟着，蒸汽把窗纸洇湿了一片。',
  w: 22, h: 18,
  counters: [{ gx: 8, gy: 3, len: 4, kind: 'eatery' }],
  props: [
    { type: 'tiled_stove', gx: 4, gy: 6 },
    { type: 'steamer_stack', gx: 6, gy: 6 },
    { type: 'dining_table', gx: 8, gy: 11 },
    { type: 'dining_table', gx: 11, gy: 11 },
    { type: 'firewood_pile', gx: 17, gy: 12 },
    { type: 'lot_bucket', gx: 18, gy: 14 },
    { type: 'waste_bin', gx: 2, gy: 15 },
  ],
  portals: [
    { to: 'market', gx: 11, gy: 17, spawn: [40, 24], label: '回市集' },
    { to: 'riverfront', gx: 1, gy: 9, spawn: [13, 22], label: '后门通河埠' },
  ],
});

export default eateryDoc;
